import { render, staticRenderFns } from "./KkBreadcrumbs.vue?vue&type=template&id=2f33a642"
import script from "./KkBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./KkBreadcrumbs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports